import { FC } from 'react';
import { formatActivityType } from '@shinetools/ape-code-library';

import InformationSection, {
  InformationSectionItem,
} from 'features/Onboarding/components/InformationSection';
import { formatDate, PPP } from 'helpers/date';
import { formatSIRET } from 'helpers/siret';

import locales from './locales';

interface LegalInformationProps {
  company: {
    activityType: string;
    legalRegistrationNumber: string;
    registrationDate: string;
  };
  onEdit?: () => void;
}

export type LegalInformationType = FC<LegalInformationProps>;

const LegalInformation: LegalInformationType = ({ company, onEdit }) => {
  const legalInformationItems: InformationSectionItem[] = [
    [
      locales.registrationDate,
      formatDate(new Date(company.registrationDate ?? ''), PPP),
    ],
    [locales.siret, formatSIRET(company.legalRegistrationNumber)],
    [locales.activity, formatActivityType(company.activityType)],
    [locales.nafCode, company.activityType],
  ];

  return (
    <InformationSection
      iconName="company"
      items={legalInformationItems}
      onEdit={onEdit}
      title={locales.legalInformation}
    />
  );
};

export default LegalInformation;
